/* eslint-disable no-unused-vars */
import React, { useContext } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { CollapseContext } from '../context/CollapseMenuContext'
import DeliveryBooking from './DeliveryBooking'
import Event from './Event'
import ItemForm from './ItemForm'
import ManageOrder from './ManageOrder'
import MembersV2 from './MembersV2'
import ProductsItems from './Products_Items'
import Settings from './Settings'
import UserProfile from './UserProfile'
import Sidebar from './components/Sidebar'
import SwitchMobileModel from './components/SwitchMobileModel'
import AllPage from './pages/AllPage'
import ListMyGroupsPage from './pages/ListMyGroups'
import ListMyPurchasesPage from './pages/ListMyPurchases'
import DashboardDesktop from './Dashboard'
import Footer from './components/Footer'
import { NavTabs } from './components/Header'
import './style.scss'

function MainDesktop() {
  return (
    <div className='main-desktop-shell'>
      <Sidebar />
      <div className='main-content-wrapper'>
        <NavTabs />
        <main className='main-content-scroll'>
          <Switch>
            <Route path='/settings' component={Settings} />
            <Route path='/user' component={UserProfile} />
            <Route path='/event' component={Event} />
            <Route path='/members' component={MembersV2} />
            <Route path='/manage-orders' component={ManageOrder} />
            <Route path='/all-page' component={AllPage} />
            <Route path='/list-my-purchases' component={ListMyPurchasesPage} />
            <Route path='/list-my-groups' component={ListMyGroupsPage} />
            <Route path='/group' component={() => <SwitchMobileModel />} />
            <Route path='/delivery-booking' component={DeliveryBooking} />
            <Route path='/products-items' exact={true} component={ProductsItems} />
            <Route path='/products-items/add' component={ItemForm} />
            <Route path='/products-items/update' component={ItemForm} />
            <Route exact path='/home' render={() => <Redirect to='/manage-orders' />} />
            <Route path='/dashboard' component={DashboardDesktop} />
          </Switch>
        </main>
        <Footer />
      </div>
    </div>
  )
}

export default MainDesktop
